import { Accordion, Alert, Button, Card, Grid, Group, Modal, Image, SimpleGrid, Space, Stack, Text, TextInput, ThemeIcon, Timeline, Title, ActionIcon, NumberInput, NumberFormatter } from '@mantine/core'
import { IconAlertCircle, IconBuildingBank, IconEdit, IconMessageDots, IconPhone, IconSchool, IconThumbDown, IconThumbUp, IconTool, IconWreckingBall, } from '@tabler/icons-react';
import EditableInfoCard from '../customers/EditableInfoCard';
import { ActionType, BaseResult, DocType, FileTag, IpoRequestObject, IpoStatusCode, KYC, ProductActionRequest, ProductRefreshRequest, UpdateLink, } from '../../types';
import { DocumentReference, QueryDocumentSnapshot, updateDoc } from 'firebase/firestore';
import { FirebaseError } from 'firebase/app';
import { useContext, useEffect, useState } from 'react';
import { httpsCallable } from 'firebase/functions';
import { useFunctions } from '../../helpers/firebaseContext';
import { MyUserDataContext } from '../../contexts';
import { useForm, UseFormReturnType } from '@mantine/form';
import GeneratePDFModal from '../../components/generate_pdf_modal';
import { CustomInfoCard } from '../customers/CustomInfoCard';
import useApprovals from '../../helpers/useApprovals';
import { FilesList } from '../../components/files';
import { modals, openConfirmModal } from '@mantine/modals';
import { fileHasTag } from '../../helpers/uploadToStorage';

export interface IpoRequestInfoProps {
    ipoRequest: IpoRequestObject,
    ipoRequestRef: DocumentReference,
    ipoRequestDoc?: QueryDocumentSnapshot<IpoRequestObject>
}


const EditShares = ({ ipoRequestRef, startingShares = 0 }: { ipoRequestRef: DocumentReference, startingShares?: number }) => {

    const [updating, setUpdating] = useState(false);
    const [shares, setShares] = useState(startingShares);

    const userData = useContext(MyUserDataContext);

    console.log("userData in EditShares", userData);


    return <>
        <NumberInput label="Number of shares" data-autofocus value={shares} onChange={(v) => setShares(Number(v))} />

        <Button loading={updating} fullWidth onClick={async () => {
            setUpdating(true);

            //change number of shares in firestore
            console.log("userData", userData);
            await updateDoc(ipoRequestRef, { shares: shares, unitsUpdatedBy: userData.user?.email || "No email" });

            setUpdating(false);
            modals.closeAll();

        }} mt="md">
            Submit
        </Button>

    </>


}
const IpoRequestInfo = ({ ipoRequestDoc, ipoRequest, ipoRequestRef }: IpoRequestInfoProps) => {

    const userData = useContext(MyUserDataContext);
    const [confirmDialog, setConfirmDialog] = useState<any>(null);
    const [confirming, setConfirming] = useState(false);
    const [refreshing, setRefreshing] = useState(false);
    const [finalSignedAgreementExists, setFinalSignedAgreementExists] = useState(false);

    const [generatePDFOpen, setGeneratePDFOpen] = useState(false);
    const [confirmDialogError, setConfirmDialogError] = useState<any>(null);
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const [links, setLinks] = useState([] as any[]);

    const [metaTypes, setMetaTypes] = useState<DocType[]>([]);  //this is for CustomerKYC to set the metatypes of files that exist on the KYC.  That way, we can populate the Generate PDF form properly.

    const paciData = (ipoRequest?.submittedData?.paciData);

    let actionToTakeLabel: string | null = null;
    let actionToTake: ActionType | null = null;
    let actionColor: string = "";
    let ipoRequestStatusCode = ipoRequest.tags?.ipoRequestStatus?.code as IpoStatusCode;

    const functions = useFunctions();
    if (ipoRequestStatusCode === IpoStatusCode.waiting_for_execution) {
        actionToTakeLabel = "Approve";
        actionToTake = "approve";
        actionColor = "cyan";
    }


    const ipoRequestAction = httpsCallable<ProductActionRequest, BaseResult>(functions, 'ipoRequestAction');
    const ipoRequestRefresh = httpsCallable<ProductRefreshRequest, BaseResult>(functions, 'ipoRequestRefresh');
    const form: UseFormReturnType<any> = useForm<any>({
        initialValues: {
            updateLink: {
                senderID: ""


            } as UpdateLink,
        }
    })


    const { actions, actionsAfterRejections } = useApprovals(ipoRequestRef);

    let sharesEditable: boolean = !ipoRequest.shares && userData.msal !== undefined;
    const checkFinalAgreementExisits = async () => {
        const isUploaded = await fileHasTag(`ipoRequests/${ipoRequest.ipoType}/${ipoRequest.company.id}/${ipoRequest.id}`, FileTag.finalSignedAgreement);
        setFinalSignedAgreementExists(isUploaded);
    }
    useEffect(() => {
        checkFinalAgreementExisits();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return (
        <div>

            <Space h="xl" />

            <Card shadow="sm" padding="lg" radius="md" withBorder>

                <Group justify="space-between" mt="md" mb="xs">
                    {/* <Button
                        onClick={

                            () => setGeneratePDFOpen(true)

                        }
                    >
                        Generate PDF
                    </Button> */}
                    <Button color="green" loading={refreshing} type="button" onClick={

                        async () => {

                            setRefreshing(true);
                            await ipoRequestRefresh({ productID: ipoRequest.id! });
                            setRefreshing(false);
                            console.warn("IpoRequest refreshed!");
                        }

                    }>
                        Refresh IpoRequest
                    </Button>

                </Group>
            </Card>
            <Space h="xl" />

            <Accordion multiple transitionDuration={1000} defaultValue={['ipoRequest',]}>
                <Accordion.Item key="ipoRequest" value="ipoRequest">
                    <Accordion.Control >
                        <Group p="apart">
                            <ThemeIcon
                                variant="gradient"
                                size="xl"
                                aria-label="Gradient action icon"
                                gradient={{ from: 'red', to: 'grape', deg: 180 }}
                            >
                                <IconTool size={30} />
                            </ThemeIcon>
                            <Text
                                component="span"
                                ta="center"
                                variant="gradient"
                                gradient={{ from: 'red', to: 'grape', deg: 180 }}
                                size="xl"
                                fw={700}
                                style={{ fontFamily: 'Greycliff CF, sans-serif' }}
                            >
                                IpoRequest Information
                            </Text>
                        </Group>
                    </Accordion.Control>
                    <Space h={"xl"} />

                    <Accordion.Panel>


                        <SimpleGrid cols={3}>

                            <EditableInfoCard
                                title="IpoRequest Information"
                                color="teal"
                                itemDoc={ipoRequestDoc}
                                updatedItemData={{}}
                                icon={<IconWreckingBall size={16} />}
                                list={[

                                    {
                                        label: 'Date',
                                        value: ipoRequest.created?.toDate().toDateString()
                                    },


                                    {

                                        label: 'Type',
                                        value: ipoRequest.ipoType
                                    },
                                    {

                                        label: 'Residency',
                                        value: ipoRequest.residency
                                    },
                                    {
                                        label: 'customer type',
                                        value: ipoRequest.customerType,
                                    },

                                    {
                                        label: ipoRequest.shares ? 'Shares' : 'enter shares value',
                                        value: <>
                                            <Text span fw={500} size="sm" ta="right">

                                                {ipoRequest.shares === 0 ? "All Shares" :
                                                    <NumberFormatter thousandSeparator value={ipoRequest.shares} />}

                                            </Text>
                                            {sharesEditable &&
                                                <>


                                                    <ActionIcon variant="white" aria-label="Edit Shares" onClick={() => {
                                                        modals.open({
                                                            title: 'Edit number of shares',
                                                            children: (
                                                                <EditShares ipoRequestRef={ipoRequestRef} startingShares={ipoRequest.shares || 0} />
                                                            ),
                                                        });
                                                    }}>
                                                        <IconEdit style={{ width: '70%', height: '70%' }} stroke={1.5} />
                                                    </ActionIcon>
                                                    {ipoRequest.shares === 0 &&

                                                        <Text size="xs" c="red" ta="right">(Please enter all available shares)</Text>

                                                    }
                                                </>
                                            }
                                        </>
                                    },
                                    {

                                        label: 'Company',
                                        value: ipoRequest.company.name_en
                                    },







                                ]}

                            />


                            <CustomInfoCard
                                title="Client Information"
                                color="yellow"
                                icon={<IconPhone size={16} />}
                                list={[
                                    {
                                        label: "Name (en)",
                                        value: ipoRequest.submittedData?.name_en,
                                    },
                                    {
                                        label: "Name (ar)",
                                        value: ipoRequest.submittedData?.name_ar,
                                    },
                                    {
                                        label: "Commercial Register",
                                        value: ipoRequest.customerObj?.commercial_register,
                                    },

                                    {
                                        label: "Customer ID Document Number (civil ID or passport)",
                                        value: ipoRequest.submittedData?.civilID || (ipoRequest.submittedData as any)?.passportNumber,
                                    },


                                    {
                                        label: "Civil ID Expiry",
                                        value: (ipoRequest.submittedData)?.civilIDExpiryDate?.toDate().toLocaleDateString("en-gb")
                                    },

                                    {
                                        label: "Mobile",
                                        value: ipoRequest.customerObj?.mobile,
                                    },
                                    {
                                        label: "Nationality",
                                        value: ipoRequest.customerObj?.nationality,
                                    },
                                    {
                                        label: "Gender",
                                        value: ipoRequest.customerObj?.gender,
                                    },
                                    {
                                        label: "PACI Sponsor",
                                        value: paciData?.PersonalData?.GovData?.SponsorName || undefined
                                    },
                                    {
                                        label: "PACI Mobile",
                                        value: paciData?.PersonalData?.MobileNumber || undefined
                                    },
                                    {
                                        label: "PACI Email",
                                        value: paciData?.PersonalData?.EmailAddress || undefined,
                                        noCapitalize: true,
                                    },

                                    {
                                        label: "Address (en)",
                                        value: (ipoRequest?.customerObj as KYC)?.address?.DetailsEnglish,
                                    },

                                    {
                                        label: "Address (ar)",
                                        value: (ipoRequest?.customerObj as KYC)?.address?.DetailsArabic,
                                    },
                                    {

                                        label: 'Power of Attorney Name',
                                        value: ipoRequest.powerOfAttorneyName
                                    },
                                    {

                                        label: 'Power of Attorney Civil ID',
                                        value: ipoRequest.powerOfAttorneyCivilID
                                    },

                                    // ...Object.keys(data?.address).map((key) => {return {label: key, value: data?.address[key]}} )
                                ]}
                            />



                            {ipoRequest?.submittedData?.signature &&


                                <CustomInfoCard
                                    title="Signature"
                                    color="violet"
                                    icon={
                                        <IconSchool size={16} />
                                    }
                                    list={[

                                        {
                                            label: '',
                                            value: ipoRequest?.submittedData?.signature && <Image
                                                fit="contain"
                                                w="auto"
                                                mah={200}
                                                maw="100%"
                                                src={`data:image/png;base64,${ipoRequest?.submittedData?.signature}`}
                                            />
                                        },


                                    ]}
                                />
                            }


                            <CustomInfoCard
                                title="Bank Account Information"
                                color="red"

                                icon={
                                    <IconBuildingBank size={16} />
                                }
                                list={[

                                    {
                                        label: 'IBAN',
                                        value: (ipoRequest?.submittedData)?.iban,
                                        noCapitalize: true,

                                    },
                                    // {
                                    //     label: 'Account',
                                    //     value: ipoRequest.acct,
                                    //     noCapitalize: true,
                                    // },
                                    {
                                        label: 'Verified',
                                        value: ipoRequest.ibanVerified,
                                        noCapitalize: true,
                                    },

                                ]}
                            />

                        </SimpleGrid>
                        {
                            <SimpleGrid my={"lg"}>

                                <Title order={3}>Files</Title>
                                <FilesList
                                    setMetaTypes={setMetaTypes}
                                    path={`ipoRequests/${ipoRequest.ipoType}/${ipoRequest.company.id}/${ipoRequest.id}`}
                                    links={links}
                                    setLinks={setLinks}
                                    showUploader={false}
                                />

                            </SimpleGrid>
                        }




                        {actions && actions.length > 0 &&
                            <Grid mt={20}>
                                <Grid.Col span={12}>



                                    <Title order={3}>Actions</Title>
                                </Grid.Col>

                                <Grid.Col span={12}>

                                    {/* <Container size="xl"> */}
                                    <Timeline active={100} bulletSize={24} lineWidth={2} reverseActive>

                                        {

                                            actions.map((action, index: number) => {
                                                // console.log(action.id, index);
                                                let verb = "Unknown";
                                                let color = "gray";
                                                let icon = <IconMessageDots size={12} />;


                                                if (action.type === "reject") {
                                                    verb = "Rejected";
                                                    color = "red";
                                                    icon = <IconThumbDown size={12} />;
                                                }
                                                else if (action.type === "approve") {
                                                    verb = "Approved";
                                                    color = "green";
                                                    icon = <IconThumbUp size={12} />;

                                                }


                                                return <Timeline.Item bullet={icon} title={verb} color={color} key={index}>
                                                    <Text c="dimmed" size="sm">{`${verb} by ${action.name}`}</Text>
                                                    {action.comments && <Text c="violet" size="sm">{action.comments}</Text>}
                                                    <Text size="xs" mt={4}>{new Date(action.date.seconds * 1000).toLocaleString("en-GB", { hour12: true })}</Text>
                                                </Timeline.Item>

                                            }).reverse()  /* reverse so the latest action is at the top */
                                        }
                                    </Timeline>
                                </Grid.Col>

                                {/* </Container> */}
                            </Grid>
                        }

                        <Group mt={20}>


                            {actionToTake &&
                                <Button disabled={

                                    false

                                }
                                    color={actionColor} type="button" name="approve" onClick={async () => {


                                        setConfirmDialog({
                                            title: "Confirm",
                                            action: actionToTakeLabel,
                                            description: `${actionToTakeLabel} ${ipoRequest.customerObj?.name_en}'s ipoRequest?`,
                                            buttonColor: actionColor,
                                            callback: async () => {
                                                //The action needs Microzift's accessToken so I can verify groups from the server side.
                                                let token = await userData.getAzureADToken!(userData);

                                                if (!token) {
                                                    throw new FirebaseError("no_microsoft_token", "No Microsoft token.  Try refreshing");
                                                }
                                                await ipoRequestAction({ action: actionToTake as ActionType, productID: ipoRequest.id!, token: token, customerID: "" });
                                                setRefreshing(true);
                                                await ipoRequestRefresh({ productID: ipoRequest.id! });
                                                setRefreshing(false);
                                                console.warn("Order refreshed!");
                                            }
                                        })
                                    }}>
                                    {actionToTakeLabel}
                                </Button>
                            }
                            {/* {
                                <Button
                                    disabled={!finalSignedAgreementExists}

                                    onClick={

                                        () => openConfirmModal({
                                            title: 'confirm',
                                            children: (
                                                <>
                                                    <Title order={3} c="red">
                                                        Are you sure you want to send the docuemnt to the client
                                                    </Title>
                                                    <Text size="xl" c="red">
                                                        This Action cannot be reverted
                                                    </Text>
                                                </>
                                            ),
                                            labels: { confirm: 'Send', cancel: 'Cancel' },
                                            // confirmProps: {
                                            //     disabled: true
                                            // }
                                            onConfirm: () => {
                                                console.log("CONFIRM SEND");

                                            },

                                        })

                                    }

                                >
                                    Send to client
                                </Button>
                            } */}



                        </Group>

                        <Modal
                            opened={confirmDialog != null}
                            onClose={() => { setConfirmDialog(null); setConfirmDialogError(null); }}
                            title={<Title order={3}>{confirmDialog?.title}</Title>}
                        >

                            <form onSubmit={form.onSubmit(async (values) => {
                                setConfirmDialogError(null);
                                setConfirming(true);
                                try {
                                    await confirmDialog?.callback(values);
                                    setConfirmDialog(null);
                                } catch (error: any) {
                                    setConfirmDialogError(error.message);
                                }
                                setConfirming(false);

                            })}>
                                <Stack>

                                    <Text fw={300}>{confirmDialog?.description}</Text>
                                    {/* <Space h="xl"/> */}
                                    {confirmDialog?.textField && <><Text>{confirmDialog?.textFieldDescription}</Text><TextInput  {...form.getInputProps(confirmDialog.textField)} /></>}
                                    <Button color={confirmDialog?.buttonColor} type="submit" loading={confirming}>{confirmDialog?.action}</Button>
                                    {confirmDialogError && <Alert icon={<IconAlertCircle size={16} />} title="Whoops!" c="red">{confirmDialogError}</Alert>}
                                </Stack>
                            </form>
                        </Modal>
                    </Accordion.Panel>
                </Accordion.Item>

            </Accordion>


            <GeneratePDFModal
                generatingForCollection="ipo"
                getCustomerDataKey={"customerObj"}
                // generatedType={"order"}
                objID={ipoRequest.id}
                rows={[{
                    ...ipoRequest,
                    ...ipoRequest?.customerObj,
                    customerID: ipoRequest?.customerObj?.civilID,
                    id: ipoRequest.id,
                    documentActions: actionsAfterRejections,

                }]}
                hidePDFOptions={true}

                fromServer={true}
                customFileName='signed Agreement'
                customPath={`ipoRequests/${ipoRequest.ipoType}/${ipoRequest.company.id}/${ipoRequest.id}`}


                // getCustomerDataKey={null}
                documentsToFetch={
                    [{
                        name: "ipoRequests",
                        subCollectionAccessorName: "id",
                        documentsToAddFunction: () => {
                            return [
                                {
                                    doNotFlatten: false,
                                    title: "Signed Agreement",
                                    path: ipoRequest.company?.filePath!
                                }
                            ]
                            // return (ipoRequestObj?.ipoRequestType) ? ipoRequestPaths[ipoRequestObj?.ipoRequestType] : []
                        },
                        type: "collection"

                    }]
                }

                metaTypes={metaTypes}
                opened={generatePDFOpen}
                setOpened={setGeneratePDFOpen}


            />

        </div >
    )
}

export default IpoRequestInfo